<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Transactions Report for Today",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        category: '',
        branch_id:0,
        title: 'Transactions Report for Today'
      },
      title: "Transactions Report",
      items: [
        {
          text: "Transactions Report",
          href: "/",
        },
        {
          text: "Transactions Report",
          active: true,
        },
      ],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      totalRows: 1,
      total_amount_in:0,
      total_amount_out:0,
      total_profit:0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_in",
          sortable: true,
          label: "AMOUNT_IN",
        },
        {
          key: "amount_out",
          sortable: true,
          label: "AMOUNT_OUT",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "DATE-TIME",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "RECORDED_BY",
        }
      ],
      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "category",
          sortable: true,
          label: "CATEGORY",
        },
        {
          key: "amount_in",
          sortable: true,
          label: "AMOUNT_IN",
        },
        {
          key: "amount_out",
          sortable: true,
          label: "AMOUNT_OUT",
        },
        {
          key: "mode",
          sortable: true,
          label: "PAYMENT MODE",
        },
        {
          key: "description",
          sortable: true,
          label: "DESCRIPTION",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "DATE-TIME",
        },
        {
          key: "recordedon",
          sortable: true,
          label: "RECORDED_BY",
        },
        {
          key: "branch",
          sortable: true,
          label: "BRANCH",
        }
      ],
      options: [
        { value: '1', label: 'Sales' },
        { value: '2', label: 'Expenses' },
        { value: '3', label: 'Purchases' },
        { value: '4', label: 'Sales Returns'},
        { value: '5', label: 'Purchase Returns'},
        { value: '6', label: 'CashOut'},
        { value: '7', label: 'CashIn'},
        { value: '8', label: 'Money Transfer'},
        { value: '9', label: 'Customer Deposits'},
      ],
      json_fields: {
        CATEGORY: "category",
        AMOUNT_IN: "amount_out",
        AMOUNT_OUT: "amount_out",
        MODE: "mode",
        DESCRIPTION : "description",
        DATE_TIME: "recordedon",
        RECORDED_BY: "recordedby",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("accounts", ["GetTransactions"]),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["business","branch","Branches","branchid"]),
    ...mapGetters("setting", ["GeneralSettings"]),
    
    /**
     * Total no. of records
     */

    rows() {
      return this.GetTransactions ? this.GetTransactions.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.GetTransactions ? this.GetTransactions.length : 1;
  },
  methods: {
    ...mapActions({
      FetchTransactions: "accounts/fetchTransactions",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBranches: "auth/fetchBranches",

    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    SetData(){
      this.FetchTransactions(this.data);
      if(this.data.category != ''){
        let cat = '';
        if(this.data.category == 1){
            cat = 'Sales';
        }else if(this.data.category == 2){
            cat = 'Expenses';
        }else if(this.data.category == 3){
            cat = 'Purchases';
        }else if(this.data.category == 4){
            cat = 'Sales returns';
        }else if(this.data.category == 5){
            cat = 'Purchases returns';
        }else if(this.data.category == 6){
            cat = 'Cashout';
        }else if(this.data.category == 7){
            cat = 'Cashin';
        }else if(this.data.category == 8){
            cat = 'Money transfers';
        }else if(this.data.category == 9){
            cat = 'Customer deposits';
        }
        this.data.title = "Transactions Report for "+cat+" From "+
        this.data.datefrom +
        " To " +
        this.data.dateto;
      }else{
        this.data.title = "Transactions Report From "+
        this.data.datefrom +
        " To " +
        this.data.dateto;
      }
    },
  },
  updated() {    
    let total_amount_out = 0;
    let total_amount_in = 0;
      if(this.GetTransactions){
        this.GetTransactions.forEach((item)=>{
          total_amount_in = total_amount_in+parseInt(item.amount_in);
          total_amount_out = total_amount_out+parseInt(item.amount_out);
        });
        this.total_amount_in = total_amount_in;
        this.total_amount_out = total_amount_out;
      }
  },

  // watch: {
  //   GetTransactions(newValue){
  //     if(newValue){
  //       this.FetchTransactions(this.data);
        
  //     }
  //   },
  // },
  
  created() {
    this.FetchTransactions(this.data);
    this.FetchGeneralSettings();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <div class="row py-3 text-center">
      <h4 v-if="GeneralSettings.show_businessname == 1" class="text-primary">{{business}}</h4><h4 v-if="GeneralSettings.show_branchname == 1 && branch"> <em  v-if="GeneralSettings.show_branchname == 1 && GeneralSettings.show_businessname == 1">-</em> {{branch}}</h4>
    </div>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>
            </div>
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>
                
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="data.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="SetData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="GetTransactions"
                  :fields="json_fields"
                  :worksheet="'TRANSACTIONS REPORT FOR' + currentdate"
                  type="csv"
                  :name="'Transactions_report' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="SetData()"
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="SetData()"
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                />
              </div>
              <div class="col-md-3 form-group">
                <label>CATEGORIES</label>
                
                <model-list-select
                  :list="options ? options : []"
                  v-model="data.category"
                  option-value="value"
                  option-text="label"
                  placeholder="Select Category"
                  @input="SetData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="GetTransactions?GetTransactions:[]"
                  :fields="branchid==0?fields1:fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
              </b-table>
                <div class="row">
                  <div class="col-md-4">
                    <h5>Total Amount In: <span class="text-danger">{{(total_amount_in).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Amount Out: <span class="text-danger">{{(total_amount_out).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Balance: <span class="text-danger">{{(total_amount_in - total_amount_out).toLocaleString()}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!GetTransactions"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
